export type DatePeriod = 'weekly' | 'biweekly' | 'monthly' | 'yeartodate';
